import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Link from "next/link";
import { useTranslation } from "next-i18next";

import { ShipdaCurrentLanguage } from "@sellernote/shared/src/i18n/i18nForShipda";
import { getPageSize } from "@sellernote/shared/src/utils/etc";
import Seo from "@sellernote/shipda-kr/src/containers/Seo";
import { supportActions } from "@sellernote/shipda-kr/src/modules/support";
import { useAppSelector } from "@sellernote/shipda-kr/src/store";
import BoardList from "@sellernote/ui/src/sds-v1/components/board/BoardList";
import BoardPageTitle from "@sellernote/ui/src/sds-v1/components/board/BoardPageTitle";
import Loading from "@sellernote/ui/src/sds-v1/components/Loading";
import Paging from "@sellernote/ui/src/sds-v1/components/Paging";

import { getServerSidePropsWithI18n } from "../../../utils/i18n";

import CommonStyled from "../index.styles";
import SupportBreadcrumb from "../SupportBreadcrumb";
import SupportLayout from "../SupportLayout";
import SupportSideMenu from "../SupportSideMenu";

export const getServerSideProps = getServerSidePropsWithI18n();

const PAGE_UNIT = 6;

export default function OnlineLecture() {
  const { t } = useTranslation(["support-new"]);

  const dispatch = useDispatch();

  const { videoDataList, videoDataTotal } = useAppSelector((state) => {
    return {
      videoDataList: state.support.GET_LIST.data?.list,
      videoDataTotal: state.support.GET_LIST.data?.total,
    };
  });

  const [page, setPage] = useState(0);

  useEffect(() => {
    fetchList();

    return () => {
      dispatch(supportActions.INIT_GET_LIST({}));
    };
  }, [page]);

  function fetchList() {
    // articleType - 게시판 종류
    const params = { articleType: "video", page, perPage: PAGE_UNIT };

    dispatch(supportActions.GET_LIST(params));
  }

  if (!videoDataList)
    return (
      <Loading active={!videoDataList} label={t("support-new:공통_로딩")} />
    );

  return (
    <SupportLayout>
      <Seo
        path="/support/onlinelecture"
        title={
          ShipdaCurrentLanguage.currentLanguage === "ko"
            ? "소개 및 영상 - 디지털 수출입 물류 포워딩 쉽다"
            : "Introduction and Video - ShipDa - Digital freight forwarding service"
        }
        description={
          ShipdaCurrentLanguage.currentLanguage === "ko"
            ? "수출, 수입운송을 전문적으로 도와줄 포워딩업체를 찾고 계시다면, 디지털 포워더 쉽다와 쉽게 시작하세요."
            : "Service introductions and video for ShipDa customers, offering comprehensive insights into ShipDa's services"
        }
      />

      <CommonStyled.mainContainer>
        <SupportBreadcrumb />

        <BoardPageTitle titleStyle="default">
          {t("support-new:공통_소개_활용_동영상")}
        </BoardPageTitle>

        <p className="board-desc">{t("support-new:동영상_확인_안내")}</p>

        <Paging
          pageSize={getPageSize(PAGE_UNIT, videoDataTotal)}
          currentPage={page}
          currentPageData={
            <BoardList
              type="video"
              listData={videoDataList}
              boardItemHref="/support/onlinelecture"
              LinkComponent={Link}
            />
          }
          handleClickPage={(p) => setPage(p)}
          isZeroBasedPage
          className="paging-video"
        />
      </CommonStyled.mainContainer>

      <SupportSideMenu />
    </SupportLayout>
  );
}
